<template>
  <section class='leaveStu'>
    <Row>
      <Breadcrumb>
        <BreadcrumbItem to="">APP管理</BreadcrumbItem>
        <BreadcrumbItem to="">用户反馈</BreadcrumbItem>
      </Breadcrumb>
    </Row>

    <section class='tabelContent'>
      <tablePage border :queryData="queryData" :searchParam='searchParam' :issearch='issearch' @smodal='sModal'>
      </tablePage>
    </section>



  </section>
</template>

<script>
import tablePage from './tablePage'

export default {
  name: 'noticelist',
  components: {
    tablePage
  },
  data () {
    return {
      smodal: false,
      reloadTmep: -1,
      initformData: [],
      queryData: ['questionAction/getQueryList?state=-1',
        [{
          title: '问题类型',
          key: 'stuname',
          width: 150,
          align: 'center',
          render: (h, params) => {
            var arr = ['功能异常', '产品建议', '安全分类', '其他问题']
            return h('span', arr[params.row.type])
          }
        },
        {
          title: '联系方式',
          key: 'phone',
          width: 150,

        }, {
          title: '添加时间',
          key: 'addtime',
        },
        {
          title: '反馈内容',
          key: 'describ',
          render: (h, params) => {
            return h('span', decodeURI(params.row.describ))
          }
        },
        {
          title: '问题截图',
          key: '',
          align: 'center',
          render: (h, params) => {
            var styles = { //设置样式
              display: 'inline-block',
              width: '30px',
              height: '30px',
              borderRadius: '3px',
              textAlign: 'center',
              lineHeight: '30px',
              marginRight: '3px'
            }

            if (params.row.pic) {
              var _pics = params.row.pic.split(',')
              var imgs = []
              _pics.map(function (val, index) {
                imgs.push(h('img', {
                  style: styles,
                  attrs: {
                    src: val
                  }
                }))
              })

              return h('viewer', imgs)
            } else {
              return ''
            }


          }
        },
        {
          title: '处理状态',
          key: 'state',
          width: 120,
          render: (h, params) => {
            var states = params.row.state == 1 ? '已处理' : '未处理'
            return h('span', states)
          }
        },

        {
          title: '操作',
          slot: 'action',
          width: 90,
          align: 'center',
          render: (h, params) => {
            var that = this
            var _state = params.row.state == 1 ? '未处理' : '已处理'
            var _newdel = params.row.state == 1 ? 0 : 1
            return h('div', [
              h('Dropdown', {
                props: {
                  trigger: "click"
                },
                on: {
                  'on-click': (value) => {
                    console.log(value) //此处的value和下面DropdownMenu选项的name对应
                    if (value == 'submit') {
                      this.sModal(params.row.guid)
                    } else if (value == 'delete') {

                      this.$Modal.confirm({
                        title: '提示',
                        content: '<p>是否确认将问题状态设置为【' + _state + '】？</p>',
                        onOk: () => {
                          that.axios.post('questionAction/changeState', {
                            guid: params.row.guid,
                            state: _newdel
                          }).then(res => {
                            ////console.log(res)
                            that.$Message.success(res.msg)
                            that.reloadTable()
                          })
                        },
                        onCancel: () => {
                        }
                      });


                    }
                  }
                }
              }, [
                h('span', {
                  style: {
                    display: 'inline-block',
                    width: '60px',
                    height: '25px',
                    background: '#2db7f5',
                    borderRadius: '6px',
                    textAlign: 'center',
                    lineHeight: '25px',
                    color: '#fff',
                    fontSize: '12px',
                    cursor: 'pointer',
                    userSelect: 'none'
                  }
                }, [
                  h('span', '操作'),
                  h('Icon', {
                    props: {
                      type: 'md-arrow-dropdown'
                    }
                  })
                ]),
                h('DropdownMenu', {
                  slot: 'list'
                }, [
                  h('DropdownItem', {
                    props: {
                      name: 'delete'
                    }
                  }, _state),

                ])
              ])
            ])



          }
        }


        ]
      ],
      searchParam: {

        begintime: '',
        endtime: '',
      },
      issearch: -1,
    }
  },
  mounted () {
    // this.initformData = JSON.parse(JSON.stringify(this.formData[1]))

    // exprotTable(tHeader, tbody, '测试')

  },
  methods: {
    exportExcel () {
      this.$Modal.confirm({
        title: '提示',
        content: '<p>正在下载数据，可能需要一定时间，请关注浏览器下载完成的信息提示</p>',
        onOk: () => {

        },
        onCancel: () => {

        }
      });
      var param = this.searchParam
      param['length'] = -1
      this.axios.get('homework/queryHomeWorkCorrect', {
        params: param
      }).then(res => {
        console.log(res)
        var tHeader = ['学生姓名', '教师姓名', '标题', '备注', '图片']

        var _data = res.data
        var arr = []
        _data.map(function (val, index) {
          val['stuname'] = decodeURIComponent(val['stuname'])
          val['teachername'] = decodeURIComponent(val['teachername'])
          val['remark'] = decodeURIComponent(val['remark'])
          val['evaluate'] = decodeURIComponent(val['evaluate'])
          arr.push({
            stuname: val['stuname'],
            teachername: val['teachername'],
            evaluate: val['evaluate'],
            remark: val['remark'],
            pics: val['pics']
          })
        })

        exprotTable(tHeader, arr, '作业面批')

      })
    },
    exportExcel2 () {
      var param = this.searchParam
      var tHeader = ['学生姓名', '教师姓名', '标题', '备注']
      var filterVal = ['stuname', 'teachername', 'evaluate', 'remark']
      util.exportExcel('homework/queryHomeWorkCorrect', param, '作业面批', tHeader, filterVal)
    },
    toApp (href) {
      this.$router.push('/appcenter#' + href)
    },
    getDateData (a, b) {

      this.searchParam.begintime = a[0]
      this.searchParam.endtime = a[1]
    },
    searchData () {
      this.issearch = Math.random()
    },
    sModal (guid, c, curpage) {
      console.log(guid, c, curpage, 'guid', this.formData[0][0])
      this.reloadTmep = Math.random()
      if (this.formData[0][0].indexOf('?') > -1) {
        this.formData[0][0] = this.formData[0][0].split('?')[0]
      }
      this.formData[0][0] = this.formData[0][0] + '?id=' + guid
      if (guid == -1) {
        this.formData[1] = JSON.parse(JSON.stringify(this.initformData))
      }
    },
    reloadTable () {
      this.issearch = Math.random()
    }
  }
}
</script>

<style scoped>
.leaveStu {
  flex: 1;
  padding-right: 25px !important;
  padding-bottom: 50px;
  padding-top: 20px;
  overflow-x: hidden;
}

.tabelContent {
  margin-top: 20px;
}

.leaveStu .ivu-row:first-of-type {
  margin-top: 5px;
}

.leaveStu .ivu-row {
  margin-top: 20px;
  /* 	overflow:hidden; */
  position: relative;
}

.leaveStu .ivu-col {
  margin-right: 10px;
  /* float:left; */
}

.leaveStu .ivu-col:last-of-type {
  float: left;
  margin-left: 10px;
  /* position:absolute;
		right:0px; */
}

.demo-upload-list {
  border: 1px solid transparent;
  border-radius: 4px;
  overflow: hidden;
  background: #fff;
  position: relative;
  overflow: hidden;
  margin-right: 4px;
  margin-bottom: 5px;
}

.demo-upload-list img {
  width: 40px;
  height: 40px;
  float: left;
  margin-right: 15px;
}

.demo-upload-list span {
  line-height: 40px;
  font-size: 12px;
  float: left;
}

.demo-upload-list-cover {
  display: none;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, .6);
}

.demo-upload-list:hover .demo-upload-list-cover {
  display: block;
}

.demo-upload-list-cover i {
  color: #fff;
  font-size: 20px;
  cursor: pointer;
  margin: 0 10px;
  line-height: 40px;

}

#hwSchool {
  position: relative;
}

#hwSchool .ivu-tree {
  position: absolute;
  top: 33px;
  left: 0px;
  background: #fff;
  z-index: 1000;
  width: 300px;
  height: 300px;
  border: 1px solid #dcdee2;
  border-top: 0 none;
  overflow-y: scroll;
  overflow-x: hidden;
  padding-left: 10px;
}

.modalUl {
  width: 100%;
  display: flex;
  justify-content: space-between;


}

.modalUl li {
  list-style: none;

}

.modalUl>li:first-of-type {
  width: 35%;
  height: 100%;
  height: 400px;
  overflow-y: scroll;
  overflow-x: hidden;
}

.modalUl>li:last-of-type {
  flex: 1;
  padding-left: 30px;
}

.treeContent {}

.hwImgCon {
  margin-top: 10px;

}

.hwImgCon img {
  width: 55px;
  height: 55px;
  border-radius: 5px;
}

.conheadRight {
  float: right;
  margin-right: 10px;
}
</style>
